// Decides which messageId a Retry/Regenerate of `assistantTurn` should
// resend. Pulled out as a pure function for the same reason
// streamFailureMessage.js was: HelpChatPanel.js's send() isn't mountable in
// this repo's test setup, so the actual regression - Retry/Regenerate
// minting a fresh messageId instead of resending the failed turn's own -
// needs a test that doesn't require mounting the component.
//
// The server's idempotency dedupe guard is keyed on messageId: a
// retry/reconnect of the SAME turn must resend the SAME id, or a tool call
// that already ran (e.g. create_want_listing) re-runs on retry and
// duplicates the write (a bug caught in review).
export function retryMessageId(assistantTurn) {
  return assistantTurn?.serverMessageId || undefined;
}
